export default [
  {
    path: "/courseIndex",
    name: "课堂-首页",
    component: () => import("@/views/onlineClass/index/index.vue"),
    meta: {
      requireAuth: false,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/courseSearchResult",
    name: "课堂-搜索结果",
    component: () =>
      import("@/views/onlineClass/searchResult/searchResult.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/courseCenter",
    name: "课堂-选课中心",
    component: () =>
      import("@/views/onlineClass/courseCenter/courseCenter.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      redirectInMobile: true, // 移动端访问的时候不用登录
      classRoomHeaderShow: true
    }
  },
  {
    path: "/selectedTopics",
    name: "课堂-精选专题",
    component: () =>
      import("@/views/onlineClass/selectedTopics/selectedTopics.vue"),
    meta: {
      requireAuth: true,
      redirectInMobile: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/courseDetail",
    name: "课堂-课程详情",
    component: () =>
      import("@/views/onlineClass/courseCenter/courseDetail.vue"),
    meta: {
      requireAuth: true,
      redirectInMobile: true, // 移动端访问的时候不用登录
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/coursePlay",
    name: "课堂-课程播放",
    component: () => import("@/views/onlineClass/courseCenter/coursePlay.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      pageClassName: "course-play-page-container", // 页面类名
      classRoomHeaderShow: true
    }
  },
  {
    path: "/excellentTeacher",
    name: "课堂-明星讲师",
    component: () =>
      import(
        "@/views/onlineClass/teachers/excellentTeacher/excellentTeacher.vue"
      ),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/teacherDetail",
    name: "课堂-讲师详情",
    component: () =>
      import("@/views/onlineClass/teachers/teacherDetail/teacherDetail.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/teacherLevel",
    name: "课堂-讲师等级",
    component: () =>
      import("@/views/onlineClass/teachers/teacherLevel/teacherLevel.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/teacherLevelRights",
    name: "课堂-讲师等级权益",
    component: () =>
      import(
        "@/views/onlineClass/teachers/teacherLevelRights/teacherLevelRights.vue"
      ),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/learnCenter",
    name: "课堂-学习中心",
    redirect: "/learnCenter/learnPlan",
    component: () => import("@/views/onlineClass/learnCenter/index.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    },
    children: [
      {
        path: "learnPlan",
        name: "课堂-学习计划",
        component: () =>
          import("@/views/onlineClass/learnCenter/myLearnPlan.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "planDetail",
        name: "课堂-学习计划详情",
        component: () =>
          import("@/views/onlineClass/learnCenter/learnPlanDetail.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myCourse",
        name: "课堂-我的课程",
        component: () => import("@/views/onlineClass/learnCenter/myCourse.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myCollection",
        name: "课堂-我的收藏",
        component: () =>
          import("@/views/onlineClass/learnCenter/myCollection.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myNotes",
        name: "课堂-我的笔记",
        component: () => import("@/views/onlineClass/learnCenter/myNotes.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myCertificates",
        name: "课堂-我的证书",
        component: () =>
          import("@/views/onlineClass/learnCenter/myCertificates.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myCertifications",
        name: "课堂-我的认证",
        component: () =>
          import("@/views/onlineClass/learnCenter/myCertifications.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      },
      {
        path: "myExam",
        name: "课堂-我的考试",
        component: () => import("@/views/onlineClass/learnCenter/myExam.vue"),
        meta: {
          requireAuth: true,
          moduleClassify: "知识",
          moduleSecondaryClassify: "课堂",
          classRoomHeaderShow: true
        }
      }
    ]
  },
  {
    path: "/examDetail",
    name: "课堂-我的考试详情",
    component: () => import("@/views/onlineClass/exam/examDetail.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/examResult",
    name: "课堂-考试结果",
    component: () => import("@/views/onlineClass/exam/examResult.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/examAnswer",
    name: "课堂-考试答案",
    component: () => import("@/views/onlineClass/exam/examAnswer.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/contestExamResult",
    name: "课堂-活动答题结果",
    component: () => import("@/views/onlineClass/exam/contestResult.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/courseClock",
    name: "课堂-9天打卡",
    component: () => import("@/views/activities/courseClock/courseClock.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂"
    }
  },
  {
    path: "/speclalCerifificationIndex",
    name: "课堂-专项认证",
    component: () =>
      import("@/views/onlineClass/specialCertification/index/index.vue"),
    meta: {
      requireAuth: true,
      redirectInMobile: true, // 移动端访问的时候不用登录
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/speclalCerifificationDetail",
    name: "课堂-专项认证详情",
    component: () =>
      import("@/views/onlineClass/specialCertification/detail/detail.vue"),
    meta: {
      requireAuth: true,
      redirectInMobile: true, // 移动端访问的时候不用登录
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/itrIndex",
    name: "课堂-itr",
    component: () => import("@/views/onlineClass/selectedTopics/itrIndex.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/myOrganization",
    name: "课堂-我的组织",
    component: () =>
      import("@/views/onlineClass/myOrganization/myOrganization.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  },
  {
    path: "/learnReport",
    name: "课堂-学习报告",
    component: () =>
      import("@/views/onlineClass/myOrganization/learnReport.vue"),
    meta: {
      requireAuth: true,
      moduleClassify: "知识",
      moduleSecondaryClassify: "课堂",
      classRoomHeaderShow: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/gtn/router/courseRouter.js